export const SEARCH_API_DOMAINS = {
    staging: 'https://discover-staging.sitecore-staging.cloud',
    prod: 'https://discover.sitecorecloud.io',
    prodEu: 'https://discover-euc1.sitecorecloud.io',
    apse2: 'https://discover-apse2.sitecorecloud.io',
};
export const ORDER_CLOUD_PROXY_DOMAIN = {
    australiaEast: 'https://australiaeast-integrations.ordercloud.io',
    europeWest: 'https://westeurope-integrations.ordercloud.io',
    japanEast: 'https://japaneast-integrations.ordercloud.io',
    usEast: 'https://useast-integrations.ordercloud.io',
    usWest: 'https://uswest-integrations.ordercloud.io',
    usWestQa: 'https://uswest-integrations.ordercloud-qa.com',
};
export const ORDER_CLOUD_SEARCH_PATH = '/api/v1/search/{{domain}}';
export const NON_SUBDOMAIN_SEARCH_PATH = '/discover/v2/{{key}}';
export const SUBDOMAIN_SEARCH_PATH = '/api/discover/v2';
export const NON_SUBDOMAIN_EVENT_PATH = '/event/{{key}}/v4/publish';
export const SUBDOMAIN_EVENT_PATH = '/api/event/v4/publish';
